import React from "react";

const EnvelopeIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.3335 2.6665C2.22893 2.6665 1.3335 3.56193 1.3335 4.6665V11.3332C1.3335 12.4377 2.22893 13.3332 3.3335 13.3332H12.6668C13.7714 13.3332 14.6668 12.4377 14.6668 11.3332V4.6665C14.6668 3.56193 13.7714 2.6665 12.6668 2.6665H3.3335ZM4.36996 5.44514C4.06361 5.2409 3.6497 5.32368 3.44546 5.63004C3.24123 5.93639 3.32401 6.3503 3.63036 6.55454L6.89076 8.72814C7.56256 9.176 8.43776 9.176 9.10956 8.72814L12.37 6.55454C12.6763 6.3503 12.7591 5.93639 12.5549 5.63004C12.3506 5.32368 11.9367 5.2409 11.6304 5.44514L8.36996 7.61874C8.14603 7.76803 7.8543 7.76803 7.63036 7.61874L4.36996 5.44514Z"
        fill="white"
      />
    </svg>
  );
};

export default EnvelopeIcon;
